export const getSizes = (): string => `
(max-width: 1023px) 100vw,
(max-width: 1440px) 50vw,
660px`;

export const setToOriginal = (url: string): string => {
  return url.replace('pdmain', 'original');
};
